(() => {
  const host = document.getElementById('cww-chatarmin-host');
  if (!host || host.dataset.initialized) return;
  host.dataset.initialized = 'true';

  const root = document.documentElement;
  const widgetId = '6ad21dd2421a3f2e16f8d267';
  const mobile = window.matchMedia('(max-width: 768.98px)');
  let privacy;
  let consent = false;
  let requested = false;
  let reloading = false;
  let frame = 0;

  function visible(element) {
    if (!element || element.hidden) return false;
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden'
      && style.opacity !== '0' && rect.width > 0 && rect.height > 0;
  }

  function deviceAllowed() {
    return host.dataset[mobile.matches ? 'mobile' : 'desktop'] === 'true';
  }

  function setProperty(element, name, value) {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  }

  function enhance(wrapper) {
    const trigger = wrapper.querySelector(`#waIcon-${widgetId}`);
    const close = wrapper.querySelector(`#closeIcon-${widgetId}`);
    const teaserClose = wrapper.querySelector(`#teaserClose-${widgetId}`);
    const panel = wrapper.querySelector('.chat_window');
    if (!trigger || !close || !panel) return;
    panel.id = 'cww-whatsapp-panel';
    panel.setAttribute('role', 'region');
    const heading = panel.querySelector('.chat_head p');
    if (heading) {
      heading.id = 'cww-whatsapp-heading';
      panel.setAttribute('aria-labelledby', heading.id);
      trigger.setAttribute('aria-label', heading.textContent);
    }
    trigger.setAttribute('aria-controls', panel.id);
    [trigger, close, teaserClose].filter(Boolean).forEach((element) => {
      element.setAttribute('role', 'button');
      element.tabIndex = 0;
      if (element !== trigger) element.setAttribute('aria-label', host.dataset.closeLabel);
      if (element.dataset.keyboardReady) return;
      element.dataset.keyboardReady = 'true';
      element.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          element.click();
        }
      });
    });
    const open = wrapper.classList.contains('open');
    trigger.setAttribute('aria-expanded', String(open));
    panel.inert = !open;
    if (!wrapper.dataset.focusReady) {
      wrapper.dataset.focusReady = 'true';
      trigger.addEventListener('click', () => {
        if (wrapper.classList.contains('open')) {
          panel.inert = false;
          close.focus({ preventScroll: true });
        }
      });
      close.addEventListener('click', () => trigger.focus({ preventScroll: true }));
      wrapper.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && wrapper.classList.contains('open')) {
          event.preventDefault();
          event.stopPropagation();
          close.click();
        }
      });
    }
  }

  function update() {
    frame = 0;
    const wrapper = host.querySelector('.chatarmin-widget-wrapper');
    const blocked = Array.from(document.querySelectorAll(
      '.js-overlay.is-visible, .modal[open], .drawer[open], dialog[open], '
      + '#pandectes-banner .cc-window, #pd-cp-preferences'
    )).some(visible);
    const show = consent && deviceAllowed() && !!wrapper && !blocked;
    if (host.hidden === show) host.hidden = !show;
    root.classList.toggle('cww-wa-visible', show);
    root.classList.toggle('cww-wa-open', show && wrapper.classList.contains('open'));
    if (!wrapper) return;
    host.dataset.state = 'loaded';
    enhance(wrapper);
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const viewportOffset = window.visualViewport?.offsetTop || 0;
    let bottom = 24 + Math.max(0, window.innerHeight - viewportHeight - viewportOffset);
    const edge = window.innerWidth - (mobile.matches ? 16 : 24);
    for (const element of document.querySelectorAll(
      'sticky-atc-panel, .products-toolbar.products-toolbar__mobile-filters-btn, #shopify-preview-bar-iframe'
    )) {
      if (!visible(element)) continue;
      const rect = element.getBoundingClientRect();
      if (rect.left < edge && rect.right > edge - 60 && rect.top < window.innerHeight && rect.bottom > 0) {
        bottom = Math.max(bottom, window.innerHeight - rect.top + 16);
      }
    }
    setProperty(host, '--cww-wa-bottom', `${Math.ceil(bottom)}px`);
    const bubble = wrapper.querySelector('.bubble');
    const teaser = wrapper.querySelector('.teaser-message.show');
    let topButton = bottom + (bubble?.getBoundingClientRect().height || 50) + 16;
    if (teaser && visible(teaser)) topButton = Math.max(topButton, window.innerHeight - teaser.getBoundingClientRect().top + 16);
    setProperty(root, '--cww-wa-top-button', `${Math.ceil(topButton)}px`);
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  function load() {
    if (requested || !consent || !deviceAllowed()) return;
    requested = true;
    const script = document.createElement('script');
    script.id = 'cww-chatarmin-script';
    script.src = `https://customized-whatsapp-widget.chatarmin.com/widget-fetcher.js?w_id=${widgetId}&u_id=69ef600cc2ffb0e6a826c60d`;
    script.async = true;
    script.addEventListener('error', () => {
      host.dataset.state = 'error';
      host.hidden = true;
    });
    host.dataset.state = 'loading';
    document.body.appendChild(script);
  }

  function syncConsent() {
    let allowed = false;
    try {
      allowed = privacy.currentVisitorConsent().marketing === 'yes' && privacy.marketingAllowed();
    } catch {
      allowed = false;
    }
    const withdrawn = consent && !allowed && requested;
    consent = allowed;
    if (withdrawn && !reloading) {
      reloading = true;
      host.hidden = true;
      root.classList.remove('cww-wa-visible', 'cww-wa-open');
      window.location.reload();
      return;
    }
    load();
    schedule();
  }

  document.addEventListener('visitorConsentCollected', () => {
    if (privacy) syncConsent();
  });
  mobile.addEventListener('change', () => {
    load();
    schedule();
  });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('transitionend', schedule, true);
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'open', 'hidden', 'style']
  });

  let attempts = 0;
  function connect() {
    attempts += 1;
    if (window.Shopify?.customerPrivacy?.currentVisitorConsent) {
      privacy = window.Shopify.customerPrivacy;
      host.dataset.state = 'consent-ready';
      syncConsent();
      return;
    }
    if (!window.Shopify?.loadFeatures) {
      if (attempts < 80) window.setTimeout(connect, 250);
      return;
    }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error || !window.Shopify.customerPrivacy) {
        host.dataset.state = 'consent-unavailable';
        return;
      }
      privacy = window.Shopify.customerPrivacy;
      host.dataset.state = 'consent-ready';
      syncConsent();
    });
  }
  connect();
})();
